// 拉端类型映射表，落地页曝光或者按钮点击
export const PULL_EVENE_TYPE_MAP = {
    'LANDPAGE_EXPOSE': '1',
    'BTN_CLICK': '2',
};
// pullType语义化映射
export const PULL_TYPE_MAP = {
    launch_action: 1,
    guid_action: 2,
    no_action: 3,
    passphrase_action: 4,
};
// linkType语义化映射
export const LINK_TYPE_MAP = {
    universal_link: 1,
    scheme: 2,
    wx_scheme: 3,
    download: 4,
    guid: 5,
    passphrase: 6,
    bridge: 7,
    weixin_tag: 8,
    ali_scheme: 9,
    show_guid: 10,
};
// 拉端请求通用参数
export const LAUNCH_APP_COMMON_PARAMS_KEY = [
    'x_act_key',
    'xid',
    'entrance_channel',
    'prod_key',
    'dchn',
    'xpsid',
    'xpsid_from',
    'xpsid_root',
    'xbiz',
    'uid',
    'xenv',
    'xspm_from',
];
// 需要预加载的图片
export const PRE_LOAD_IMGS = ['https://ut-static.udache.com/webx/ut/PyKSaY5Qhtp25CyqnYP2y.png'];
// linkType和技术埋点映射
export const LINK_TYPE_EVENTID_MAP = {
    1: 'launch_app_passenger_btn_click',
    2: 'launch_app_passenger_btn_click',
    3: 'launch_app_mini_btn_click',
    4: 'launch_app_download_btn_click',
    8: 'launch_app_passenger_btn_click'
};
// 技术埋点与业务埋点映射
export const LAUNCH_EVENEID_TO_OMEGA_EVENTID_MAP = {
    launch_app_force_pull_popup_expose: {
        eventId: 'userteam_ldfw_force_pull_popup_sw',
        label: '拉端服务-弹窗曝光'
    },
    launch_app_passenger_btn_click: {
        eventId: 'userteam_ldfw_passenger_btn_ck',
        label: '拉端服务-跳转app按钮点击'
    },
    launch_app_mini_btn_click: {
        eventId: 'userteam_ldfw_mini_btn_ck',
        label: '拉端服务-跳转小程序按钮点击'
    },
    launch_app_download_btn_click: {
        eventId: 'userteam_ldfw_download_btn_ck',
        label: '拉端服务-下载app按钮点击'
    },
    launch_app_passphrase_popup_expose: {
        eventId: 'userteam_ldfw_command_pop_sw',
        label: '拉端服务-口令展示弹窗曝光'
    },
    launch_app_passphrase_copy_btn_click: {
        eventId: 'userteam_ldfw_copy_command_btn_ck',
        label: '拉端服务-复制口令按钮点击'
    },
    launch_app_passphrase_copy_success_popup_expose: {
        eventId: 'userteam_ldfw_copy_command_succ_sw',
        label: '拉端服务-复制口令成功探测曝光'
    },
    launch_app_passphrase_close_popup_btn_click: {
        eventId: 'userteam_ldfw_close_command_btn_sw',
        label: '拉端服务-关闭口令弹窗按钮点击'
    },
    launch_app_user_guide_popup_expose: {
        eventId: 'userteam_ldfw_user_guide_popup_sw',
        label: '拉端服务-引导蒙层展现曝光'
    },
    launch_app_command_copy_ck: {
        eventId: 'userteam_ldfw_command_copy_ck',
        label: '拉端服务-复制口令'
    },
};
// 使用 fusion 无法打开的scheme
export const INVALIDSCHEMELIST = [
    // 'rebound', // 首页， fusion 部分场景无法打开
    'router/page/web',
    'dache_anycar/scenehome',
    'weixin',
    'alipays',
];
